
export * from './lib/feature-dns-resolve-time';
